/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Uploads_Former_MemberInputs */



/**
* | output |
* | --- |
* | "Former member" |
*
* @param {Chat_Uploads_Former_MemberInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_uploads_former_member = /** @type {((inputs?: Chat_Uploads_Former_MemberInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Uploads_Former_MemberInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ehemaliges Mitglied")
	return /** @type {LocalizedString} */ ("Former member")
});